import { NgModule } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { URLSearchParams } from '@angular/http';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateService } from '@ngx-translate/core';

import { environment as config } from '../environments/environment';

export function createTranslateLoader(http: Http) {
  return new TranslateHttpLoader(http, `${config.translations.baseUrl}/apps/bo.walle.smsrobot.text/translations/`, '');
}

@NgModule({
  imports: [TranslateModule.forRoot({
  loader: {
    provide: TranslateLoader,
    useFactory: (createTranslateLoader),
    deps: [Http]
  }
})],
  exports: [TranslateModule],
  providers: [TranslateService]
})
export class AppSharedModule {
  constructor(
    private translate: TranslateService
  ) {
    const urlParams = new URLSearchParams(window.location.search.slice(1));
    const locale = urlParams.get('locale');
    if(!locale) {
      console.warn('You didn\'t provide a locale');
    }
    translate.use(locale);
  }
}



// WEBPACK FOOTER //
// /www/sms-simulator/sms-front/src/app/app.shared.module.ts